import { ChatBox } from '@rumblefish/ui/Rumblefish23Theme';
import parse from 'html-react-parser';
import React from 'react';
import { data } from './ChatUseCases.data';
import {
  StyledChatSection,
  StyledColumnInfoWrapper,
  StyledFrame,
  StyledHeadline,
  StyledHeadlineDescription,
  StyledInfoDescription,
  StyledInfoTitle,
  StyledSingleInfoWrapper,
  StyledSection,
  StyledStack,
  StyledHeadlineWrapper,
  StyledChatWrapper,
  OtherInfoWrapperRow,
} from './styles';
export const ChatUseCases = () => {
  return (
    <StyledSection width="normal">
      <StyledStack>
        <StyledFrame>
          <StyledHeadlineWrapper>
            <StyledHeadline variant="display_sm">
              {data.headline.title}
            </StyledHeadline>
            <StyledHeadlineDescription variant="strong_400">
              {parse(data.headline.description)}
            </StyledHeadlineDescription>
          </StyledHeadlineWrapper>

          {data.chatsSections.map((el, IndexChatSections) => {
            const shouldReverse = IndexChatSections % 2 != 0;
            return (
              <StyledChatSection
                reverse={shouldReverse}
                key={IndexChatSections}>
                <StyledColumnInfoWrapper>
                  {el.infoSections.map((section, indexSingleInfo) => (
                    <StyledSingleInfoWrapper
                      reverse={shouldReverse}
                      key={indexSingleInfo}>
                      <StyledInfoTitle variant="strong_500">
                        {section.title}
                      </StyledInfoTitle>
                      <StyledInfoDescription variant="regular_400">
                        {section.description}
                      </StyledInfoDescription>
                    </StyledSingleInfoWrapper>
                  ))}
                </StyledColumnInfoWrapper>
                <StyledChatWrapper>
                  <ChatBox
                    messages={el.chatBoxProps.messages}
                    useFingerPrint={el.chatBoxProps.useFingerPrint}
                  />
                </StyledChatWrapper>
              </StyledChatSection>
            );
          })}

          {data.otherInfoRows.map((el, indexRow) => {
            return (
              <OtherInfoWrapperRow key={indexRow}>
                {el.infoSections.map((section, index) => {
                  const shouldReverse = index % 2 != 0;
                  return (
                    <StyledSingleInfoWrapper
                      reverse={shouldReverse}
                      key={index}>
                      <StyledInfoTitle variant="strong_500">
                        {section.title}
                      </StyledInfoTitle>
                      <StyledInfoDescription variant="regular_400">
                        {section.description}
                      </StyledInfoDescription>
                    </StyledSingleInfoWrapper>
                  );
                })}
              </OtherInfoWrapperRow>
            );
          })}
        </StyledFrame>
      </StyledStack>
    </StyledSection>
  );
};
